import { HrpBaseClient } from './HrpBaseClient'

export class HrpDepartmentClient extends HrpBaseClient {
  constructor(
    hrpProxyApiUrl = process.env.HRP_PROXY_API_URL,
    hrpProxySecretName = process.env.HRP_PROXY_SECRET_NAME,
    axiosOptions
  ) {
    super(hrpProxyApiUrl, hrpProxySecretName, axiosOptions)
  }

  async getDepartments({ accountHccIdentifier }) {
    await this.createSecureAxiosInstance()

    if (!accountHccIdentifier || typeof accountHccIdentifier !== 'string') {
      throw new Error(`Account HCC identifier needs to be a valid string`);
    }

    const params = {
      departmentCriteriaType: {
        // conversion due to some inputs that can happen using # format
        accountHccIdentifier: accountHccIdentifier.replaceAll('#', '-')
      }
    };

    try {
      const response = await this.secureAxiosInstance.post(
        `/admin/api/department/v4/getDepartmentLookup`,
        params
      )

      return response.data
    }
    catch (e) {
      throw e.response
    }
  }
}
